// This is an example for doc upload functionality provided by @ey/voltron-doc-upload
import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function uploadTaskDocumentsReducer(state = [], action) {
	switch (action.type) {
		case 'UPCHUNK_CREATE_DOCUMENT_METADATA': {
			// Add response object into state
			let newState = _.cloneDeep(state);
			// Get modified the assignment by id.
			let currentDocument = newState.find((x) => x.fileId === action.data.fileId);
			if (currentDocument) {
				if (action?.error?.response?.status === 412) {
					// pre-condition failed
					// may be due to duplicate file
					currentDocument.isDuplicate = true; // show duplicate pop up to show user
				} else {
					currentDocument.documentId = action.response.id;
					currentDocument.createDate =
						action.response.createDate === '0001-01-01T00:00:00' ? new Date() : action.response.createDate;
					currentDocument.isDuplicate = false;
				}

				return newState;
			}
		}
		case 'UPCHUNK_START_UPLOAD': {
			if (action.meta.upchunk && action.meta.upchunk.payload) {
				state = [
					...state,
					{
						fileId: action.meta.upchunk.payload.fileId,
						documentId: 0,
						fileName: action.meta.upchunk.payload.file.name,
						documentName: action.meta.upchunk.payload.file.name,
						file: {
							name: action.meta.upchunk.payload.file.name,
							size: action.meta.upchunk.payload.file.size,
							_uploadTag: action.meta.upchunk.payload.file._uploadTag,
							fileId: action.meta.upchunk.payload.fileId,
							type: action.meta.upchunk.payload.file.type
						},
						progressPercent: 0,
						relatedEntityId: action.meta.upchunk.payload.clientRequestId,
						totalPercentage: 100,
						source: action?.meta?.source,
						engagementId: action?.meta?.engagementId,
						userId: action?.meta?.userId
					}
				];
			}
		}
		case 'UPCHUNK_COMPLETE_DOCUMENT_UPLOAD': {
			// alert('document uplaod is complete now!');
			console.log('UPLOAD Complete ACTION =>', action);
			// update status to trigger associate call
			if (action?.response?.documentId) {
				// upload complete now
				// Add response object into state
				let newState = _.cloneDeep(state);
				// Get modified the assignment by id.
				let currentDocument = newState.find((x) => x.documentId === action?.response?.documentId);
				if (currentDocument) {
					currentDocument.uploadComplete = true;
					return newState;
				}
			}
		}
		case 'ASSOCIATE_EXISTING_DOCUMENT': {
			return state.filter((element) => element.documentId !== action?.meta?.api?.data?.documentId);
		}
		case 'CLEAR_CLIENTREQUEST_DOCUMENT': {
			return state.filter((element) => element.fileId !== action?.fileId);
		}
		case 'CLIENTREQUEST_OVERWRITE_DOCUMENT': {
			if (action?.parentName === 'clientrequest') {
				let newState = _.cloneDeep(state);
				let currentDocument = newState.find((x) => x.fileId === action?.meta?.fileId);
				if (currentDocument) {
					currentDocument.isOverwrite = action?.meta?.isOverwrite;
					return newState;
				}
			}
		}
		case 'ASSOCIATE_CLIENTREQUEST_DOCUMENT': {
			if (!action?.meta?.upchunk?.payload?.relatedEntityId) {
				// this is new request.. please remove file from collection
				return state.filter((element) => element.documentId !== action.meta.upchunk.payload.documentId);
			} else {
				// Add response object into state
				let newState = _.cloneDeep(state);

				// Get modified the assignment by id.
				let currentDocument = newState.find((x) => x.documentId === action.meta.upchunk.payload.documentId);
				if (currentDocument) {
					currentDocument.associateTriggered = true;
					return newState;
				}
			}
		}
		case 'UPCHUNK_DOCUMENT_UPLOAD_PROGRESS': {
			if (action?.meta?.upchunk?.payload) {
				// Add response object into state
				let newState = _.cloneDeep(state);
				// Get modified the assignment by id.
				let currentDocument = newState.find((x) => x.documentId === action.meta.upchunk.payload.documentId);
				if (currentDocument) {
					if (
						currentDocument.progressPercent !== action.meta.upchunk.payload.progressPercent ||
						currentDocument.inProgress !== action.meta.upchunk.payload.inProgress
					) {
						currentDocument.progressPercent = action.meta.upchunk.payload.progressPercent;
						currentDocument.inProgress = action.meta.upchunk.payload.inProgress;
						return newState;
					}
				}
			}
		}
		case 'DOCUMENT_ERRORS': {
			// remove file which failed to upload from the list
			let newState = state.filter((element) => element.fileId !== action?.action?.meta?.upload?.fileId);
			return newState;
		}
		case 'UPCHUNK_DOCUMENT_UPLOAD_CANCELLED': {
			// Put back to default state
			return [];
		}
		case 'UPCHUNK_UPLOAD_ERROR': {
			// remove file which failed to upload from the list
			let newState = state.filter((element) => element.fileId !== action?.meta?.fileId);
			return newState;
		}
	}

	return state;
}
